import { gql } from "@apollo/client";

export const CREATE_ASSIGNPERFORMANCE = gql`
  mutation createAssignPerformance($input: createAssignedPerformanceInput) {
    createAssignPerformance(input: $input) {
      id
    }
  }
`;

export const GET_ASSIGNPERFORMANCE = gql`
  query AssignPerformance($assignPerformanceId: Int) {
    assignPerformance(id: $assignPerformanceId) {
      selectPerformance
      assignedUsers
      department
      endDate
      id
      role
      project
      startDate
      templateId
    }
  }
`;

export const ALL_ASSIGNPERFORMANCE = gql`
  query GetAssingedPerformance {
    getAssingedPerformance {
      id
      selectPerformance
      department
      role
      startDate
      endDate
      assignedUsers
    }
  }
`;
